module.exports = __webpack_public_path__ + "img/hr-tree-01-c-trunk.99f36efe.png";